enum TableType {
	MainTable = 'Main Table',
	UserTable = 'UserTable',
	History = 'History',
	Transfer = 'Transfer',
}

export default TableType;
